// extracted by mini-css-extract-plugin
export default {"hidden":"e05e18"};